// The round status mark used by Compliance and Konfiguration (styles: .cmp-si in CompliancePage.css).
// `status` is Compliance's vocabulary: covered (green tick), partial (half circle), notFound (cross),
// unknown/external (dash). Konfiguration maps its ok/warn/bad/neutral tones onto the same four.
import React from 'react';

const TONE = { covered: 'ok', partial: 'warn', notFound: 'bad', unknown: 'neutral', external: 'neutral', unlicensed: 'neutral' };

export default function StatusIcon({ status, label, size = 20 }) {
  const tone = TONE[status] || 'neutral';
  return (
    <svg className={`cmp-si cmp-si--${tone}`} width={size} height={size} viewBox="0 0 24 24" role="img" aria-label={label}>
      <circle cx="12" cy="12" r="11" className="cmp-si__bg" />
      {status === 'covered' && <path d="M7.5 12.4l3 3 6-6.6" className="cmp-si__g" fill="none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />}
      {status === 'partial' && (
        <>
          <circle cx="12" cy="12" r="5.2" fill="none" className="cmp-si__g" strokeWidth="2" />
          <path d="M12 6.8a5.2 5.2 0 010 10.4z" className="cmp-si__f" />
        </>
      )}
      {status === 'notFound' && <path d="M8.6 8.6l6.8 6.8M15.4 8.6l-6.8 6.8" className="cmp-si__g" fill="none" strokeWidth="2.2" strokeLinecap="round" />}
      {(status === 'unknown' || status === 'external' || status === 'unlicensed') && <path d="M8.5 12h7" className="cmp-si__g" fill="none" strokeWidth="2.2" strokeLinecap="round" />}
    </svg>
  );
}
